import { inject, injectable } from "inversify";

import JobTitle from "@model/JobTitle";
import AssociatedCreateViewModel from "@vm/Create/AssociatedCreateViewModel";
import JobTitleFormVM from "@vm/Form/JobTitle";
import ContractsVM from "@vm/Other/Contracts";

import TYPES from "../../inversify.types";
import EventBus, { JOB_TITLES_UPDATED } from "@util/EventBus";

// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class JobTitleCreateVM extends AssociatedCreateViewModel<JobTitle, AssociatedRepository<JobTitle>> {
  constructor(
    @inject(TYPES.JobTitleRepository) repository: AssociatedRepository<JobTitle>,
    @inject(TYPES.Contracts) private contractsVM: ContractsVM,
    @inject(TYPES.JobTitleForm) public jobTitleFormVM: JobTitleFormVM
  ) {
    super(JobTitle, repository);
  }

  async create(): Promise<number | undefined> {
    this.entity.contract_id = this.contractsVM.contractId!;
    const result = await super.create();
    if (result) {
      EventBus.trigger(JOB_TITLES_UPDATED);
    }
    return result;
  }

  setEntity(entity: JobTitle) {
    super.setEntity(entity);
    this.jobTitleFormVM.setEntity(entity);
  }

  init(employeeId: number, contractId: number) {
    this.setParentId(employeeId);
    this.jobTitleFormVM.init(employeeId, contractId);
  }

  resetEntityAndErrors() {
    super.resetEntityAndErrors();
    this.jobTitleFormVM.setEntity(this.entity);
  }
}
